export const OWNERSHIP_TYPE = {
    '1': 'Leased',
    '2': 'Permanent Transfer',
    '3': 'Not Transfer to KVS',
} as const;

export const LOCATION_TYPE = {
    '1': 'URBAN',
    '2': 'RURAL',
    '3': 'Abroad'
} as const;

export const SPONSORED_BY = {
    '0': 'Foreign',
    '1': 'Civil',
    '2': 'Defence',
    '3': 'Institute of Higher Learning (IHL)',
    '4': 'Project'
} as const;

export const STATION_TYPE = {
    '1': 'Normal',
    '2': 'Hard',
    '3': 'North East',
    '4': 'Abroad'
} as const;

export const SCHOOL_BUILDING = {
    '1': 'Permanent',
    '2': 'Temporary'
} as const;

export const INFRA_FACILITY = {
    '1': 'Yes',
    '2': 'No'
} as const;

export const PM_SHRI_PHASE = {
    '0': 'Non PM Shri',
    '1': 'Phase 1',
    '2': ' Phase 2',
    '3': 'Phase 3',
    '5': 'Phase 5',
    '7': 'Phase 7'
} as const;

export const INTERNET_PLAN = {
    '0': 'No Plan',
    '13': 'Below 1 Mbps',
    '1': '1 Mbps',
    '2': '2 Mbps',
    '3': '5 Mbps',
    '4': '10 Mbps',
    '5': '20 Mbps',
    '6': '50 Mbps',
    '7': '100 Mbps',
    '8': '200 Mbps',
    '9': '300 Mbps',
    '10': '500 Mbps',
    '11': '1 Gbps',
    '12': 'Above 1 Gbps',
} as const;

export const CONTACT_ROLE = {
    '1': 'Principal / Incharge Principal',
    '2': 'Vice Principal 1 / Senior Most Teacher',
    '3': 'Vice Principal 2',
    '4': 'Head Master 1/ Senior Most Teacher(PRT)',
    '5': 'Head Master 2',
} as const;

export const INFRA_SIZE_TYPE = {
    '11': 'Type A-1 Without Lab',
    '12': 'Type A-1 With Lab',
    '2': 'Type A',
    '3': 'Type B',
    '4': 'Type C',
    '5': 'Type D',
    '6': 'Type E',
} as const;

export const INTERNET_TYPE = {
    '0': 'No Internet',
    '1': 'Broad Band',
    '2': 'Lease Line',
    '3': 'Optical Fibre Cabel',
    '6': 'Air Fiber',
    '4': 'V-SAT',
    '5': 'Others'
} as const;

export const INTERNET_CONNECTIVITY = {
    '1': 'Yes',
    '0': 'No'
} as const;

export const NCC_GROUP = {
    '1': 'Army',
    '2': 'Air',
    '3': 'Naval',
} as const;

export const NCC_GROUP_WING = {
    '1': 'Jr. Wing',
    '2': 'Sr. Wing',
} as const;

export const NCC_GROUP_ANO_CTO = {
    '1': 'ANO',
    '2': 'CTO',
} as const;

export const NCC_ANO_CTO_RANK = {
    '1': 'Rank 1',
    '2': 'Rank 2',
    '3': 'Rank 3',
    '4': 'N/A',
} as const;

export const COMPARISON = {
    '=': 'Equal To',
    '>': 'Greater than',
    '<': 'Less than',
    '>=': 'Greater than or equal to',
    '<=': 'Less than or equal to',
} as const;

export const LAB_FUNDED_BY = {
    '1': 'NITI Aayog',
    '2': 'PM SHRI',
    '3': 'KV VVN',
    '4': 'Others',
    '5': 'CSR',
} as const;

export const LIBRARY_AUTOMATION_SOFTWARE_NAME = {
    '1': 'E-Granthalaya 4.0',
    '2': 'E-Granthalaya 3.0',
    '3': 'Inhouse Software',
    '4': 'Others',
    '5': 'Not Installed',
} as const;

export const SPORT_CATEGORY = {
    Standard: 'Standard',
    Ordinary: 'Ordinary'
} as const;

export const SPORT_TYPE = {
    Indoor: 'Indoor',
    Outdoor: 'Outdoor'
} as const;

// Sport Title/Name mapping from master_sports table
export const SPORT_TITLE = {
    '1': 'Athletics Track & Field (200 M)',
    '2': 'Athletics Track & Field (400 M)',
    '3': 'Archery Arena (Up to 30-60 M)',
    '4': 'Badminton Court',
    '5': 'Basketball Court',
    '6': 'Boxing Ring',
    '8': 'Cricket Field',
    '9': 'Football Field',
    '10': 'Handball Ground',
    '11': 'Hockey Ground',
    '12': 'Judo Arena (With Mat)',
    '13': 'Kabaddi Court',
    '14': 'Kho-Kho Ground',
    '15': 'Lawn Tennis',
    '16': 'Rope Skipping Arena',
    '17': 'Mallkhamb (Pole)',
    '18': 'Shooting Range',
    '19': 'Skating Rink',
    '20': 'Swimming & Diving Pool',
    '21': 'Table Tennis Hall (With TT Board)',
    '22': 'Taekwondo Arena (With Mat)',
    '23': 'Volleyball Court',
    '24': 'Yoga Room',
    '25': 'Wrestling Arena',
    '26': 'Multi-Sports Hall'
} as const;

export const SPORT_QUALITY = {
    Clay: 'Clay',
    RCC: 'RCC',
    Synthetic: 'Synthetic',
    Wooden: 'Wooden',
    Turf: 'Turf',
    Sinder: 'Sinder',
} as const;

export const SPORT_MEASURE_UNIT = {
    '1': 'Meter',
    '2': 'Feet'
} as const;

export const RAMP_GROUND_FLOOR = {
    '1': 'Yes',
    '0': 'No'
} as const;


export const EMPLOYEE_TYPE = {
    '1': 'New',
    '2': 'Existing',
    '3': 'Surplus',
    '4': 'VRS',
    '5': 'Retired',
    '6': 'Suspended'
} as const;

export const BUILDING_TYPE = {
    '11': 'Type A-1 Without Lab',
    '12': 'Type A-1 With Lab',
    '2': 'Type A',
    '3': 'Type B',
    '4': 'Type C',
    '5': 'Type D',
    '6': 'Type E',
} as const;

export const INFRA_NAME = {
  '1': 'Computer Lab 1',
  '2': 'Physics Lab',
  '3': 'Jr. Sci. Lab',
  '4': 'Social Sci/Geo Room',
  '5': 'Resource Room (Primary)',
  '6': 'Multi Purpose Hall',
  '7': 'Art Room',
  '8': 'WE Room / Workshop',
  '9': 'Library',
  '10': 'Maths Lab',
  '11': 'Principal Room',
  '12': 'Office',
  '13': 'Staff Common Room',
  '14': 'Vice-Principal Room',
  '15': 'Head Master/Head Mistress Room',
  '16': 'Exam. Room',
  '17': 'NCC Room',
  '18': 'Sports Room',
  '19': 'Store Room',
  '20': 'Medical Room',
  '21': 'Class Rooms',
  '22': 'Scout Guide Room',
  '23': 'Chemistry Lab',
  '24': 'Biology Lab',
  '25': 'ATL Lab',
  '26': 'Vocational Lab',
  '27': 'Guard Room',
  '28': 'Computer Lab 2',
  '29': 'Computer Lab 3',
  '30': 'Language Lab',
  '31': 'Resource Room (Secondary)',
  '32': 'AI/Robotics Lab',
  '33': 'AR/VR Lab',
  '34': 'Assembly Stage (Covered)',
  '35': 'Assembly Stage (Open)',
  '36': 'Music Room',
  '37': 'Staff Quarter Type 1',
  '38': 'Staff Quarter Type 2',
  '39': 'Staff Quarter Type 3',
  '40': 'Staff Quarter Type 4',
  '41': 'Staff Quarter Type 5'
} as const;

const LOOKUP_MAPS = {
    OWNERSHIP_TYPE,
    LOCATION_TYPE,
    SPONSORED_BY,
    STATION_TYPE,
    SCHOOL_BUILDING,
    INFRA_FACILITY,
    PM_SHRI_PHASE,
    INTERNET_PLAN,
    CONTACT_ROLE,
    INFRA_SIZE_TYPE,
    INTERNET_TYPE,
    INTERNET_CONNECTIVITY,
    NCC_GROUP,
    NCC_GROUP_WING,
    NCC_GROUP_ANO_CTO,
    NCC_ANO_CTO_RANK,
    COMPARISON,
    LAB_FUNDED_BY,
    LIBRARY_AUTOMATION_SOFTWARE_NAME,
    SPORT_CATEGORY,
    SPORT_TYPE,
    SPORT_TITLE,
    SPORT_QUALITY,
    SPORT_MEASURE_UNIT,
    RAMP_GROUND_FLOOR,
    EMPLOYEE_TYPE,
    BUILDING_TYPE,
    INFRA_NAME,
};

export default LOOKUP_MAPS;
